var mailing_list_notice = ( function( $ ) {

	var $notice = false;
	var $html = false;

	var _init = function() {
		$notice = $( '#mailing-list-notice' );
		$html   = $( 'html' );

		_setup();
	};

	var _setup = function() {
		if ( ! has_been_seen() ) {
			$notice.find( '.close' ).on( 'click', _close_click_event );
			$notice.find( '.title-bar' ).on( 'click', _open_responsive );

			open();
		}
	};

	var _close_click_event = function( e ) {
		e.preventDefault();
		set_seen();
		close();
	};

	var set_seen = function() {
		$.cookie( 'mailing_list_notice_seen', 'true', { expires: 7, path: '/' } );
	};

	var has_been_seen = function() {
		return $.cookie( 'mailing_list_notice_seen' );
	};

	var _open_responsive = function() {
		var $main = $notice.find( '.main-content' );

		$main.slideDown();
	};

	var open = function() {
		$notice.removeAttr( 'hidden' );
	};

	var close = function() {
		$notice.slideUp();
	};

	$( document ).ready( _init );

	return {
		set_seen : set_seen,
		has_been_seen : has_been_seen,
		open : open,
		close : close
	};

} )( jQuery );

module.exports = mailing_list_notice;